





















import { mapActions } from 'vuex';
import { ZenObjectTable } from 'zenComponents';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { getRequest } from '../../utils/client/client';

export default {
  name: 'DashboardListPage',
  components: {
    ZenObjectTable,
    LoadingSpinner,
  },
  data() {
    return {
      loading: true,
      columns: ['title', 'description'],
      data: [],
    };
  },
  created() {
    this.setPageTitle({ title: 'Benchmarks' });
    this.getBenchmarks();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    getBenchmarks() {
      getRequest({ url: '/dashboards/benchmarks' }).then(data => {
        this.data = data.items;
        this.loading = false;
      });
    },
  },
};
